import { render } from "./SessionExpiryAlert.vue?vue&type=template&id=780d9a4a&scoped=true"
import script from "./SessionExpiryAlert.vue?vue&type=script&lang=js"
export * from "./SessionExpiryAlert.vue?vue&type=script&lang=js"

import "./SessionExpiryAlert.vue?vue&type=style&index=0&id=780d9a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780d9a4a"]])

export default __exports__